import React from 'react'
import { useMediaQuery } from 'react-responsive'

import { StyledMasthead, Body, Leaves, BottomLeaves, Frame } from './styles'

import leaves from './../../../img/masthead-leaves.png'
import frame from './../../../img/masthead-frame.png'
import frameMobile from './../../../img/masthead-frame-mobile.png'

import { devicesMax } from './../../styles/breakpoints'

const Masthead = ({ children }) => {
  const isMaxTabletSm = useMediaQuery({ query: devicesMax.mobile.lg })

  return (
    <StyledMasthead>
      {/* <Frame viewBox="0 0 551.5 360.8">
      <path
        d="M490 318h1v-1a86 86 0 0122-48c25-27 38-57 38-89s-13-62-38-89a86 86 0 01-22-47v-1h-1c-23-6-42-21-51-41V1h-1c-39 5-110 7-162 7S153 6 113 1h0l-1 1c-8 20-28 35-51 41h-1v1a86 86 0 01-22 47c-24 27-37 58-37 89s13 62 37 89a86 86 0 0122 48v1h1c23 5 43 21 51 41l1 1h0c40-5 110-7 163-7s123 2 162 7h1v-1c9-20 28-36 51-41z"
        fill="none"
        stroke="#b8151b"
        strokeMiterlimit={10}
        strokeWidth={1.5}
      />
      <path
        opacity={0.5}
        d="M479 309l1-1h0a79 79 0 0121-45c23-25 35-54 35-83s-12-57-35-83a79 79 0 01-21-44v-1h-1c-22-5-40-19-49-38v-1h-1a1511 1511 0 01-307 0h-1v1c-8 19-26 33-48 38h-1v1a79 79 0 01-21 44c-23 26-35 54-35 83s12 58 35 83a79 79 0 0121 45h0l1 1c22 5 40 19 48 38v1h1a1515 1515 0 01307 0h1v-1c9-19 27-33 49-38z"
        fill="none"
        stroke="#b8151b"
        strokeMiterlimit={10}
        strokeWidth={4}
      />
    </Frame> */}

      <Frame src={isMaxTabletSm ? frameMobile : frame} />

      <Leaves src={leaves} />

      <Body>{children}</Body>

      <BottomLeaves src={leaves} />
    </StyledMasthead>
  )
}

export default Masthead
